import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
    const [content, setContent] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/content");
            setContent(data);
        } catch (e) {
            console.error("Failed to load content", e);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { refresh(); }, [refresh]);

    return (
        <ContentContext.Provider value={{ content, loading, refresh, setContent }}>
            {children}
        </ContentContext.Provider>
    );
}

export function useContent() {
    const ctx = useContext(ContentContext);
    if (!ctx) throw new Error("useContent must be used within ContentProvider");
    return ctx;
}
